//#region Util Imports

import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'

//#endregion

import { LocalizationHelper } from '../../helpers'

//#region Public Types

export const VALIDATION_CONTROLS_SERVICE_NAME = 'ValidationControlsService'
export const VALIDATION_CONTROLS_SERVICE_PROVIDER_NAME = 'ValidationControlsServiceProvider'

//#endregion


export class ValidationControlsService {

    //#region Ctor

    constructor() { }

    //#endregion


    //#region Number

    public getPositiveIntegerRule() {
        return {
            type: 'pattern',
            pattern: '^[0-9]{0,}$',
            message: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.IntegerField)
        }
    }

    public getNumberGreaterThanRule(value: number) {
        return {
            type: 'range',
            min: value,
            message: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NumberMinValue) + ' ' + value.toString()
        }
    }

    //#endregion


    //#region Required

    public getRequiredRule(): DevExpress.ui.RequiredRule {
        return {
            type: "required",
            message: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.RequiredField)
        }
    }

    //#endregion
}

export class ValidationControlsServiceProvider implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [function () {
        return new ValidationControlsService()
    }]

    //#endregion
} 